import 'babel-polyfill';
import promise from 'es6-promise';
promise.polyfill();

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/js/js.js';
import './assets/js/vant.js';
import '@vant/touch-emulator';

import axios from './http';

import qs from 'qs';
import * as tools from './assets/js/tools';

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import VueWeChatTitle  from 'vue-wechat-title'
Vue.use(VueWeChatTitle)

Vue.prototype.$tools = tools;
import base from './assets/js/base';
Vue.use(base);

Vue.config.productionTip = false;
Vue.prototype.$qs = qs;
Vue.prototype.$axios = axios;

import './icons/index.js';

import xss from 'xss'
Vue.prototype.$xss = xss

import wxShare from './assets/js/WeChatShare';
Vue.use(wxShare);

import VueTypedJs from 'vue-typed-js' // 打字效果插件
Vue.use(VueTypedJs)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default global options } */)

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js